import { render, staticRenderFns } from "./MediaControlsVideo.vue?vue&type=template&id=6bc3d871&scoped=true&"
import script from "./MediaControlsVideo.vue?vue&type=script&lang=js&"
export * from "./MediaControlsVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc3d871",
  null
  
)

export default component.exports